// extracted by mini-css-extract-plugin
export default {"announcements-alerttext-container":"AnnouncementsPanel_announcements-alerttext-container__Wh2mJ","info-circle":"AnnouncementsPanel_info-circle__VwPSI"};